import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';
import { useCart } from '../context/CartContext';
import SiteNavbar from './SiteNavbar';
import SiteFooter from './SiteFooter';

const OrderConfirmed = () => {
  const navigate = useNavigate();
  const { clearCart } = useCart();
  const [params] = useSearchParams();
  const pending = params.get('status') === 'pending';

  // O pedido já foi criado no backend; limpamos o carrinho ao chegar aqui.
  useEffect(() => {
    clearCart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <SiteNavbar />
      <Container className="text-center py-5" style={{ maxWidth: 560 }}>
        <div style={{ fontSize: '4rem', lineHeight: 1 }}>{pending ? '⏳' : '✅'}</div>
        <h2 className="mt-3 mb-2">
          {pending ? 'Pagamento em processamento' : 'Pedido confirmado!'}
        </h2>
        <p className="text-muted">
          {pending
            ? 'Assim que o pagamento for aprovado, você receberá a confirmação por e-mail e seu pedido será preparado para envio.'
            : 'Recebemos seu pagamento. Você receberá a confirmação e os detalhes do envio por e-mail. Obrigado por comprar na Wilboor!'}
        </p>
        <div className="d-grid gap-2 mt-4" style={{ maxWidth: 320, margin: '0 auto' }}>
          <Button variant="warning" size="lg" onClick={() => navigate('/')}>
            Continuar comprando
          </Button>
          <Button variant="outline-secondary" onClick={() => navigate('/minha-conta')}>
            Ver minha conta
          </Button>
        </div>
      </Container>
      <SiteFooter />
    </div>
  );
};

export default OrderConfirmed;
